export function setNcm( ncm ) { 
    return ({
        type: 'SET_NCM',
        payload: ncm
    })
}

export function setCest( cest ) {
    return ({
        type: 'SET_CEST',
        payload: cest
    })
}

export function setCfop( cfop ) {
    return ({
        type: 'SET_CFOP',
        payload: cfop
    })
}

export function setIcms( icms ) {
    return ({
        type: 'SET_ICMS',
        payload: icms
    })
}

export function setNcmData (data) {
    return ({
        type: "SET_NCM_DATA",
        payload: data
    })
}
export function setCestData (data) {
    return ({
        type: "SET_CEST_DATA",
        payload: data
    })
}

export function setCfopData (data) {
    return ({
        type: "SET_CFOP_DATA",
        payload: data
    })
}
export function setIcmsData (data) {
    return ({
        type: "SET_ICMS_DATA",
        payload: data
    })
}

export function setIpi (data) {
    return ({
        type: "SET_IPI_DATA",
        payload: data
    })
}

export function setPis (data) {
    return ({
        type: "SET_PIS_DATA",
        payload: data
    })
}



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/actions.js